<template>
  <v-app id="wall">
    <div v-if="poll" class="wall" :style="{ backgroundColor: getBgColor(poll) }">
      <vote-simple
        v-if="question.type === 'SIMPLE' || question.type === 'QUIZZ'"
        v-bind="{ poll, question, answers, stats }"
      />
      <vote-duo
        v-if="question.type === 'DUO'"
        v-bind="{ poll, question, stats }"
        :answers="stats.answers.slice(0, 2)"
      />
      <podium
        v-if="question.type === 'CONTEST' || question.type === 'COURSE'"
        v-bind="{ poll, question, answers, stats }"
      />
    </div>
    <no-active-polls v-else />
  </v-app>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { isNil } from 'ramda';
import VoteSimple from './VoteSimple.vue';
import VoteDuo from './VoteDuo.vue';
import Podium from './Podium.vue';
import FontService from '@/services/FontService';
import NoActivePolls from '@/components/NoActivePolls';

export default {
  name: 'Wall',
  components: {
    VoteSimple,
    VoteDuo,
    Podium,
    NoActivePolls
  },
  computed: {
    ...mapGetters(['poll', 'question', 'answers']),
    ...mapState(['stats'])
  },
  created() {
    FontService.load();
  },
  mounted() {
    this.$store.dispatch('getActivePoll');
    setInterval(() => {
      this.$store.dispatch('getActivePoll');
    }, 2 * 1000);
  },
  data: () => ({
    defaultBgColor: '#9e7a7a'
  }),
  watch: {},
  methods: {
    getBgColor(poll) {
      return isNil(poll.jsStyle) ? this.defaultBgColor : poll.jsStyle.backgroundColor;
    },
    checkGraphType(jsStyle) {
      if (jsStyle) {
        const { graphType } = jsStyle;
        return graphType.value || graphType;
      }
    }
  }
};
</script>
<style lang="scss">
html {
  overflow: hidden;
}

.wall {
  height: 100%;
  overflow: hidden;
}
.theme--light.application {
  background: #ffffff;
}
</style>
